import {
  FiAlertCircle,
  FiArrowLeft,
  FiCalendar,
  FiCheck,
  FiChevronRight,
  FiClock,
  FiFileText,
  FiHelpCircle,
  FiHome,
  FiInbox,
  FiInfo,
  FiUser,
  FiUsers,
} from "react-icons/fi";

export const AlertIcon = FiAlertCircle as any;
export const BackIcon = FiArrowLeft as any;
export const CalendarIcon = FiCalendar as any;
export const CheckIcon = FiCheck as any;
export const ChevronRightIcon = FiChevronRight as any;
export const ClockIcon = FiClock as any;
export const FileTextIcon = FiFileText as any;
export const HelpIcon = FiHelpCircle as any;
export const HomeIcon = FiHome as any;
export const InboxIcon = FiInbox as any;
export const InfoIcon = FiInfo as any;
export const UserIcon = FiUser as any;
export const UsersIcon = FiUsers as any;
